import React, { useRef } from "react";
import { useDispatch } from "react-redux";

import Button from "components/common/Button";
import { AlertType } from "components/common/Snackbar";
import Dialog, { DialogContent, DialogActions } from "components/common/Dialog";
import DependentsModalContent from "./DependentsModalContent";

import { formatDate } from "util/utils";
import { setDependentsDetails } from "services/Dependents";
import { showSnackbar } from "store/actions/Utility";

function DependentsModal({ open, onClose, employeeId, initialData, initialTab = 0, onSaveSuccess }) {
  const formRef = useRef();
  const dispatch = useDispatch();

  const handleConfirm = async () => {
    try {
      const formData = formRef.current?.getFormData();

      const today = new Date("12-12-1990").toISOString().split("T")[0];

      const setFormatDate = (date) => {
        if (!date || date === "") return null;

        const dateObj = new Date(date);
        if (Number.isNaN(dateObj.getTime())) {
          throw new Error("Invalid date format");
        }

        return formatDate(date);
      };

      const dependants = [];

      if (formData.fatherName) {
        dependants.push({
          name: formData.fatherName,
          relationship: "parent",
          dateOfBirth: today,
          nationalId: formData.fatherNationalID || null,
          gender: "Male",
        });
      }

      if (formData.motherName) {
        dependants.push({
          name: formData.motherName,
          relationship: "parent",
          dateOfBirth: today,
          nationalId: formData.motherNationalID || null,
          gender: "Female",
        });
      }

      if (formData.spouseName) {
        dependants.push({
          name: formData.spouseName,
          relationship: "spouse",
          dateOfBirth: setFormatDate(formData.spouseDateOfBirth),
          nationalId: formData.spouseNationalID || null,
          gender: "Male",
        });
      }

      if (formData.children && formData.children.length > 0) {
        formData.children.forEach((child) => {
          if (child.name) {
            dependants.push({
              name: child.name,
              relationship: "child",
              dateOfBirth: setFormatDate(child.dateOfBirth),
              nationalId: child.nationalID || null,
              gender: "Male",
            });
          }
        });
      }

      const apiData = { dependants };

      if (employeeId) {
        const { success } = await setDependentsDetails(employeeId, apiData);
        if (success) {
          dispatch(showSnackbar({ type: AlertType.success, message: "Dependents updated successfully", dispatch }));
          onClose();
          if (onSaveSuccess) {
            onSaveSuccess();
          }
        } else {
          dispatch(showSnackbar({ type: AlertType.error, message: "Failed to update dependents details", dispatch }));
        }
      }
    } catch (error) {
      const errorMessage =
        error.message === "Invalid date format"
          ? "Please enter a valid date format"
          : "An error occurred while saving dependents details";

      dispatch(showSnackbar({ type: AlertType.error, message: errorMessage, dispatch }));
    }
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={onClose}
        width="600px"
        title={<p className="heading-h2-semibold">Dependents</p>}
        content={
          <DialogContent>
            <DependentsModalContent ref={formRef} initialData={initialData} initialTab={initialTab} />
          </DialogContent>
        }
        actions={
          <DialogActions
            action1={<Button label="Cancel" size="large" variant="text" onClick={handleClose} />}
            action2={
              <Button
                label="Save"
                size="large"
                variant="contained"
                color="primary"
                onClick={handleConfirm}
                isDisabled={false}
              />
            }
          />
        }
        size="sm"
      />
    </div>
  );
}

export default DependentsModal;
